class FilterLoadMore {
    constructor() {
      this.addInitialListeners();
    }
  
    addInitialListeners() {
      const initHandler = () => this.init();
      document.addEventListener('mousemove', initHandler, { once: true, passive: true });
      document.addEventListener('scroll', initHandler, { once: true, passive: true });
    }
  
    init() {
      document.querySelectorAll('[data-load-more]').forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          this.loadMore(e.target);
        });
      });
    }
  
    loadMore(button) {
      const container = button.previousElementSibling;
      const items = container.querySelectorAll('.filter-item[style*="display: none"]');
      const itemsToShow = 12;
      
      items.forEach((item, index) => {
        if (index < itemsToShow) {
          item.style.display = '';
        }
      });
  
      if (container.querySelectorAll('.filter-item[style*="display: none"]').length === 0) {
        button.style.display = 'none';
      }
    }
  }
  
  new FilterLoadMore();

  